import { dataLayerFormAction, dataLayerFreetext } from '../../js/utils/dataLayers';

let isActive = false;

const postDataLayer = (formName, fieldValue) => {
    dataLayerFormAction(formName, 'field', false, fieldValue);
};

const state = formName => {
    if (!isActive) {
        dataLayerFormAction(formName, 'start', false);
    }
    isActive = true;
};

const formValues = (form, formName) => {
    const fields = form.querySelectorAll('.form-control');

    for (let i = 0; i < fields.length; i += 1) {
        fields[i].addEventListener('change', e => {
            const field = e.target.closest('.form-field');
            const errorMessage = field.querySelector('.field-validation-error');

            if (errorMessage) {
                if (e.target.value) {
                    errorMessage.classList.add('sr-only');
                } else {
                    errorMessage.classList.remove('sr-only');
                }
            }

            if (e.target.nodeName === 'SELECT') {
                const fieldValue = {
                    field: e.target.name,
                    value: e.target.value
                };

                if (e.target.value !== '') {
                    postDataLayer(formName, fieldValue);
                }
            }
        });

        fields[i].addEventListener('blur', e => {
            if (e.target.type === 'text' || e.target.type === 'email' || e.target.nodeName === 'TEXTAREA') {
                if (e.target.value !== '') {
                    dataLayerFreetext(formName, e.target.name);
                }
            }
        });

        // eslint-disable-next-line no-loop-func
        fields[i].addEventListener('click', e => {
            state(formName);

            if (e.target.type === 'checkbox' || e.target.type === 'radio') {
                let fieldValue = {
                    field: e.target.name,
                    value: e.target.value
                };

                if (e.target.type === 'checkbox') {
                    fieldValue = {
                        field: e.target.name,
                        value: e.target.checked
                    };
                }

                postDataLayer(formName, fieldValue);
            }
        });
    }
};

export default formValues;
